import { SiblingPath } from "@aztec/aztec.js";

import type { ZodFor } from "@aztec/foundation/schemas";
import type { L2ToL1MembershipWitness } from "@aztec/stdlib/messaging";
import { schemas } from "@aztec/stdlib/schemas";
import { z } from "zod";

export const L2ToL1MembershipWitnessSchema: ZodFor<L2ToL1MembershipWitness> = z.object({
  root: schemas.Fr,
  leafIndex: schemas.BigInt,
  siblingPath: SiblingPath.schema,
});
